import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

const Title = ({title}) => (
    <h2 className="sharing-title">{title}</h2>
);

Title.propTypes = {
    title: PropTypes.string.isRequired
};

export default Title;



// WEBPACK FOOTER //
// ./src/components/Title/index.js